import { render, staticRenderFns } from "./BurgerTwo.vue?vue&type=template&id=39e3d181&scoped=true&"
import script from "./BurgerTwo.vue?vue&type=script&lang=js&"
export * from "./BurgerTwo.vue?vue&type=script&lang=js&"
import style0 from "./BurgerTwo.vue?vue&type=style&index=0&id=39e3d181&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Fburger&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e3d181",
  null
  
)

export default component.exports